import React from "react";
import { Avatar, Box, ButtonBase, Grid, Paper, Skeleton, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {
  FiberNew,
  Autorenew,
  CheckCircle,
  Cancel,
  Assignment,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const kpiConfig = [
  { key: "totalRepairRequests", icon: Assignment, color: "#1976d2", bg: "#e3f2fd" },
  { key: "newCount", icon: FiberNew, color: "#ff9800", bg: "#fff3e0" },
  { key: "inProgressCount", icon: Autorenew, color: "#ff9800", bg: "#fff3e0" },
  { key: "completedCount", icon: CheckCircle, color: "#4caf50", bg: "#e8f5e9" },
  { key: "rejectedCount", icon: Cancel, color: "#f44336", bg: "#fbe9e7" },
];

const DashboardKPITiles = ({ data, loading, onTileClick }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      {kpiConfig.map(({ key, icon: Icon, color, bg }) => {
        const value = data?.[key] ?? 0;
        const clickable = !loading && value > 0 && onTileClick;
        return (
          <Grid key={key} size={{ xs: 6, sm: 4, md: "grow" }}>
            <ButtonBase
              component="div"
              disabled={!clickable}
              onClick={clickable ? () => onTileClick(key) : undefined}
              sx={{ display: "block", width: "100%", textAlign: "left", borderRadius: 1 }}
            >
              <Paper
                className={classes.tile}
                elevation={1}
                sx={clickable ? { "&:hover": { boxShadow: 3 } } : undefined}
              >
                <Box className={classes.header}>
                  <Typography variant="body2" color="text.secondary" className={classes.label}>
                    {t(`dashboard.kpi.${key}`)}
                  </Typography>
                  <Avatar sx={{ bgcolor: bg, width: 40, height: 40 }}>
                    <Icon sx={{ fontSize: 22, color }} />
                  </Avatar>
                </Box>
                {loading ? (
                  <Skeleton width={80} height={44} />
                ) : (
                  <Typography variant="h4" fontWeight={700} className={classes.value}>
                    {value}
                  </Typography>
                )}
              </Paper>
            </ButtonBase>
          </Grid>
        );
      })}
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  tile: {
    padding: theme.spacing(2),
    minHeight: 110,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    breakInside: "avoid",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  label: {
    lineHeight: 1.3,
    paddingRight: theme.spacing(1),
  },
  value: {
    marginTop: theme.spacing(1),
  },
}));

export default DashboardKPITiles;
